module.exports = __webpack_public_path__ + "img/turn-off.87bc0d8d.svg";